import { EventEmitter, Injectable } from "@angular/core";
import { UserService } from "../../../api/services/user.service";

import { AuthApiService } from "./auth.service";
import { map, tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { FCCService } from "../../../api/services/fcc.service";
import { CoreJpatsServices } from './core-jpats.services';
import { LocationsMaintenanceService } from "../../../api/services/locations-maintenance.service";
import { LocationModel } from "../../../api/models/location-model";


@Injectable()
export class LocationManagementService {
  public static currentData: any;

  constructor(private locationsMaintenanceService: LocationsMaintenanceService, private coreJpatsService: CoreJpatsServices) {

  }

  createLocation() {
    return this.locationsMaintenanceService.Create().pipe(map((result) => {
      return result;
    }));
  }

  getLocations(filter: any) {
    let params: LocationsMaintenanceService.QueryParams = {
      FccKey: filter.fccKey,
      Page: filter.Page,
      PageSize: filter.rows,
      Facility: filter.facility,
      StateCode: filter.stateCode,
      IncludeInactive: filter.includeInactive
    };

    return this.locationsMaintenanceService.Query(params).pipe(map((result) => {
      return result;
    }));
  }

  updateLocation(location: LocationModel): Observable<LocationModel> {
    return this.locationsMaintenanceService.Save(location).pipe(map((res) => {
      return res.model;
    }));

    return new Observable<LocationModel>();
  }

}
